module.exports = __webpack_public_path__ + "static/media/beach.0bdade1a.jpg";